// 출퇴근/연차 헤더 액션 버튼 (Phase 1-2 후속, 옵션 C 통일)
//   데스크탑: 아이콘 + 텍스트 (padding 6/12, 폰트 13, 아이콘 16)
//   모바일:   아이콘만 (정사각형 32×32, 아이콘 18-20)
//   active prop: 토글 상태 (재직중 = 활성 #6366f1, 그 외 회색)
import React from 'react';

export function HeaderActionBtn({ isMobile, onClick, icon, text, active = false, title }) {
  if (isMobile) {
    return (
      <button
        onClick={onClick} title={title || text} aria-label={title || text}
        style={{
          width: 32, height: 32, padding: 0, borderRadius: 8, cursor: 'pointer',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          border: '1px solid var(--border)',
          background: active ? '#6366f1' : 'var(--bg-card)',
          color: active ? '#fff' : 'var(--text-sub)',
        }}
      >
        {icon}
      </button>
    );
  }
  return (
    <button
      onClick={onClick} title={title || text}
      style={{
        padding: '6px 12px', borderRadius: 8, cursor: 'pointer',
        display: 'inline-flex', alignItems: 'center', gap: 6,
        fontSize: 13, fontWeight: 600,
        border: '1px solid var(--border)',
        background: active ? '#6366f1' : 'var(--bg-card)',
        color: active ? '#fff' : 'var(--text-sub)',
      }}
    >
      {icon}
      <span>{text}</span>
    </button>
  );
}
